import { render, staticRenderFns } from "./ListagemCompradores.vue?vue&type=template&id=866443d2"
import script from "./ListagemCompradores.vue?vue&type=script&lang=js"
export * from "./ListagemCompradores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports